import { render } from "./APMain.vue?vue&type=template&id=773c43a3&scoped=true"
import script from "./APMain.vue?vue&type=script&lang=js"
export * from "./APMain.vue?vue&type=script&lang=js"

import "./APMain.vue?vue&type=style&index=0&id=773c43a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-773c43a3"]])

export default __exports__